// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ControllerBoard_wrapper__2diz6"};